package com.fireavert.events.shared.data_models.models.responses

import com.fireavert.events.shared.data_models.models.DeviceEvent
import com.fireavert.events.shared.data_models.models.EventLinkedAction
import kotlinx.serialization.Serializable

@Serializable
data class EventsAndActionsResponse(val events: List<DeviceEvent>, val actions: List<EventLinkedAction>)
